import React, { useEffect } from 'react'
import $ from 'jquery'

function CustomSelect({ Items, value, setValue, placeholder }) {

  useEffect(() => {

    const closeAllSelect = (elem) => {
      let tempArray = []
      const selectSelected = $('.select-selected')
      selectSelected.each((index, selected) => {
        if (elem === selected) {
          tempArray.push(index)
        } else {
          selectSelected[index].classList.remove("select-arrow-active")
        }
      });
      $('.select-items').each((index, item) => {
        if (tempArray.indexOf(index)) item.classList.add('select-hide')
      })
    }

    if ($('.select-selected').length === 0) {

      const customSelect = $('.custom-select')

      customSelect.each((index, select) => {
        const selectElement = select.getElementsByTagName('select')[0]

        const divSelected = document.createElement('DIV')

        divSelected.setAttribute('class', 'select-selected')
        divSelected.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML
        select.appendChild(divSelected)

        const divOptionsParent = document.createElement('div');
        divOptionsParent.setAttribute('class', 'select-items select-hide')
        for (let i = 1; i < selectElement.length; i++) {
          const divOptions = document.createElement('div')
          divOptions.innerHTML = selectElement.options[i].innerHTML;
          divOptions.addEventListener('click', (e) => {
            const selectParent = e.target.parentNode.parentNode.getElementsByTagName('select')[0]
            const previousSibling = e.target.parentNode.previousSibling
            for (let j = 0; j < selectParent.length; j++) {
              if (selectParent.options[j].innerHTML === e.target.innerHTML) {
                selectParent.selectedIndex = j
                selectParent.dispatchEvent(new Event('change', { bubbles: true }))
                previousSibling.innerHTML = e.target.innerHTML
                const sameElements = e.target.parentNode.getElementsByClassName('same-as-selected')
                Array.from(sameElements).forEach(element => element.removeAttribute('class'))
                e.target.setAttribute('class', 'same-as-selected')
                break;
              }
            }
            previousSibling.click()
          })
          divOptionsParent.appendChild(divOptions)
        }

        select.appendChild(divOptionsParent)

        divSelected.addEventListener('click', (e) => {
          e.stopPropagation()
          closeAllSelect(e.target)
          e.target.nextSibling.classList.toggle('select-hide')
          e.target.classList.toggle('select-arrow-active')
        })
      })
      document.addEventListener('click', closeAllSelect)
    }

  }, [])

  return (
    <div className="custom-select">
      <select value={value} onChange={(e) => { setValue(e.target.value) }}>
        <option value="" disabled>{placeholder}</option>

        {Array.isArray(Items) ?
          Object.values(Items).map((item) => {
            return (
              <option value={item}
                key={'option-' + item}>
                {item}
              </option>
            )
          }) :
          Object.keys(Items).map((item) => {
            return (
              <option value={item}
                key={'option-' + item}>
                {item}
              </option>
            )
          })
        }
      </select>
    </div>
  )
}

export default CustomSelect